export default {
  orderDetails: {
    id: 'bo_sellers-orders-drawers-order_recap-order_details-title',
    defaultMessage: 'Order details',
  },
  shipping: {
    id: 'bo_sellers-orders-drawers-order_recap-order_details-shipping',
    defaultMessage: 'Shipping',
  },
  tax: {
    id: 'bo_sellers-orders-drawers-order_recap-order_details-tax',
    defaultMessage: 'Tax',
  },
  total: {
    id: 'bo_sellers-orders-drawers-order_recap-order_details-total',
    defaultMessage: 'Total',
  },
} as const
